var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmrImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.549,
    height: 27.067,
    viewBox: "0 0 20.549 27.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1381717",
    "data-name": 1381717,
    d: "M3.3,12.128q-.162.328-.318.637a10.825,10.825,0,0,0-1.588,5.178,8.275,8.275,0,1,0,16.549,0c0-3.876-1.834-6-3.608-8.05C12.784,8.1,11.321,6.409,11.321,3.822a5.773,5.773,0,0,1,.033-.615,13.8,13.8,0,0,0-1.42,1.924A15.557,15.557,0,0,0,7.968,15.786l.218,1.446-1.352-.558a6.138,6.138,0,0,1-3.046-3.222,9.048,9.048,0,0,1-.49-1.325Zm0,0",
    transform: "translate(0.608 -1.207)",
    fill: "none",
    stroke: "#394f65",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmrImage);
export default __webpack_public_path__ + "static/media/bmr_image.b74aa42f23f479f08382d0dbe5a8d58c.svg";
export { ForwardRef as ReactComponent };